import View from '../View/View';

export * from './ThemeProvider.shared';

export const ThemeProvider = View;
